// extracted by mini-css-extract-plugin
export default {"appFooter":"AppFooter_appFooter__VTUFk"};